"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var PriceWithValidity_1 = require("../../product/model/PriceWithValidity");
/**
 * <p>The general entity representing an exported price without specific context. See the attributes description for more info.</p>
 *
 * @author JMe
 */


var ExportedPriceWithValidity =
/*#__PURE__*/
function (_PriceWithValidity_1$) {
  _inherits(ExportedPriceWithValidity, _PriceWithValidity_1$);

  /**
   * Ctor.
   *
   * @param value The price value. If rounded value is empty, this value represents the exported price value. If rounded value is not
   *        empty, this value represents the original value computed or directly entered by user.
   * @param valueRounded The rounded price value. If filled, this should be the value which was exported.
   * @param validFrom The price validity start date.
   * @param validTo The price validity end date. If null, it means that exported price is so called open price.
   * @param deleted Flag indicating whether the exported price was eventually deleted before it became valid (represented by true value).
   *        The firstly exported price should be typically exported as valid price and thus default value is false.
   */
  function ExportedPriceWithValidity(value, valueRounded, validFrom, validTo) {
    var _this;

    var deleted = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, ExportedPriceWithValidity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceWithValidity).call(this, value, valueRounded, validFrom, validTo));
    _this.value = value;
    _this.valueRounded = valueRounded;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.deleted = deleted;
    return _this;
  }
  /**
   * @returns New copy with {@link .deleted} set to true.
   * @throws An error if this instance is already marked as deleted.
   */


  _createClass(ExportedPriceWithValidity, [{
    key: "delete",
    value: function _delete() {
      if (this.deleted) {
        throw new Error("Exported price already marked as deleted!");
      }

      return this.copy('deleted', true);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "{ validFrom: ".concat(this.validFrom.toISOString(), ", validTo: ").concat(this.validTo && this.validTo.toISOString(), ", value: ").concat(this.value.toString(), ", deleted: ").concat(this.deleted, ", valueRounded: ").concat(this.valueRounded && this.valueRounded.toString(), " }");
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ExportedPriceWithValidity(mat.value, mat.valueRounded, mat.validFrom, mat.validTo, mat.deleted);
    }
  }]);

  return ExportedPriceWithValidity;
}(PriceWithValidity_1.PriceWithValidity);

exports.ExportedPriceWithValidity = ExportedPriceWithValidity;

ExportedPriceWithValidity.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ExportedPriceWithValidity.name);
  return {
    value: builder.bigNum('value'),
    valueRounded: builder.opt(builder.bigNum('valueRounded')),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.opt(builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)),
    deleted: builder.bool('deleted')
  };
}();